<template>
  <div class="layout-wrapper-maxw pa-4 pa-md-6 pb-md-12">
    <slot />
  </div>
</template>
